import { Flex, FlexProps } from '@chakra-ui/react';
import { useColorModeValue } from '@chakra-ui/react';
import React, { useMemo } from 'react';
import Footer from 'src/components/atoms/Footer';
import { SideNavBar } from 'src/components/templates/Sidebar';
import { StickyRibbon } from 'src/components/atoms/StickyRibbon';
import { IS_DEV } from 'src/constants';
import { useFilterContext } from 'src/contexts/FilterContext';
import { InitialModelLoadingScreen } from 'src/components/templates/InitialModelLoadingScreen';
import { MfaNudgeBanner } from 'src/components/organisms/MfaNudgeBanner';
import { useAppContext } from 'src/contexts/AppContext';

export const NavBarLayout: React.FC<FlexProps> = (props) => {
  const { currentAppService, modelVersionsState } = useFilterContext();
  const { subscriptionLevels } = useAppContext();
  const bg = useColorModeValue(
    'background.light.highest',
    'background.dark.lowest',
  );

  const shouldShowInitialModelLoader = useMemo(() => {
    if (!currentAppService) {
      return false;
    }

    const serviceIsEnabled = Boolean(subscriptionLevels[currentAppService]);

    if (!serviceIsEnabled) {
      return false;
    }

    if (modelVersionsState.isError) {
      return false;
    }

    if (modelVersionsState.isLoading) {
      return true;
    }

    return modelVersionsState.modelVersions.length === 0;
  }, [currentAppService, modelVersionsState, subscriptionLevels]);

  return (
    <SideNavBar>
      <Flex
        direction="column"
        align="flex-start"
        wrap="wrap"
        minH="100vh"
        w="100%"
        bg={bg}
        className="page-wrapper"
        {...props}>
        <Flex direction="column" w="100%">
          <MfaNudgeBanner />
          <Flex className="content-wrapper" flex="1" w="100%">
            {shouldShowInitialModelLoader ? (
              <InitialModelLoadingScreen />
            ) : (
              props.children
            )}
          </Flex>
          <Footer />
        </Flex>
        {IS_DEV && <StickyRibbon />}
      </Flex>
    </SideNavBar>
  );
};
